import {debug} from "util";

let ajaxurl:string;
export class AsyncAjax{
    public static async Post<t>(action:string,data:any={},resultFormat:ResultFormat="OnlyResult"):Promise<t>
    {
        return new Promise<t>(async (resolve)=>{
            let result=await AsyncAjax.PostRaw<t>(action,data);
            resolve(result.result);
        });
    }

    public static async PostRaw<t>(action:string,data:any={},resultFormat:ResultFormat="OnlyResult"):Promise<AsyncResult<t>>
    {
        let dataToSend:any={};
        dataToSend.action=action;
        if(typeof data=='object')
            data=JSON.stringify(data);
        dataToSend.data=data;
        return new Promise<AsyncResult<t>>((resolve)=>{
            jQuery.post((window as any).ajaxurl,dataToSend)
                .done((result)=>{
                    resolve(JSON.parse(result));
                })
                .fail((xhr:any,status,error)=>{
                    console.log('Error In Post Request:'+error);
                });

        });
    }

    public static async CancellablePost<t>(action:string,data:any={},cancelationToken:CancellationToken):Promise<t>
    {
        return new Promise<t>(async (resolve)=>{
            let result=await AsyncAjax.CancellablePostRaw<t>(action,data,cancelationToken);
            resolve(result.result);
        });
    }

    public static async CancellablePostRaw<t>(action:string,data:any={},cancelationToken:CancellationToken):Promise<AsyncResult<t>>
    {
        let dataToSend:any={};
        dataToSend.action=action;
        if(typeof data=='object')
            data=JSON.stringify(data);
        dataToSend.data=data;
        return new Promise<AsyncResult<t>>((resolve)=>{
            jQuery.post((window as any).ajaxurl,dataToSend)
                .done((result)=>{
                    if(!cancelationToken.WasCancelled)
                    {
                        resolve(JSON.parse(result));
                    }
                })
                .fail((xhr:any,status,error)=>{
                    console.log('Error In Post Request:'+error);
                });



        });
    }




}

export type ResultFormat='OnlyResult'|'All';

export class CancellationToken{
    private _cancel:boolean=false;
    public Cancel(){
        this._cancel=true;
    }

    get WasCancelled(){
        return this._cancel;
    }
}

export interface AsyncResult<T>{
    success:boolean;
    errorMessage:string;
    result:T;
}